'use client'

import { trackPageView } from '@/lib/tracking'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

type PageViewTrackerProps = {
  pageName?: string
  pageProps?: Record<string, unknown>
}

/**
 * Component that can be included in layout files to automatically track page views
 * Uses the Next.js usePathname and useSearchParams hooks for better compatibility
 */
export function PageViewTracker({ pageName, pageProps }: PageViewTrackerProps) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  
  useEffect(() => {
    // Use provided pageName or default to pathname
    const name = pageName || pathname || ''
    
    // Extract search params into object
    const queryParams: Record<string, string> = {}
    if (searchParams) {
      searchParams.forEach((value, key) => {
        queryParams[key] = value
      })
    }
    
    // Track the page view
    trackPageView(name, {
      query_params: Object.keys(queryParams).length > 0 ? queryParams : undefined,
      ...pageProps
    })
  }, [pathname, searchParams, pageName, pageProps])
  
  // This component doesn't render anything
  return null
} 